import i18next from 'i18next';

window.i18n = window.i18next = i18next;

import i18nextXHRBackend from 'i18next-xhr-backend';
import i18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import jqueryI18next from 'jquery-i18next';

export const initialize = function () {
	return new Promise((resolve, reject) => {
		// Must load before our modules
		/** @namespace Netx.custom.i18n */
		const options = (Netx.custom.i18n = {
			/**
			 * i18n - List of namespaces utilized
			 * @memberof Netx.custom.i18n
			 * @const
			 * @type {array}
			 * @default
			 */
			NAMESPACES: ['translation'],
			/**
			 * i18n - Default namespace to use
			 * @memberof Netx.custom.i18n
			 * @const
			 * @type {string}
			 * @default
			 */
			NAMESPACE_DEFAULT: 'translation',
			/**
			 * i18n - Default language (falls back to this if language specified can not be found)
			 * @memberof Netx.custom.i18n
			 * @const
			 * @type {string}
			 * @default
			 */
			LANGUAGE_DEFAULT: 'en-US',
			/**
			 * i18n - Whitelist of languages allowed to load
			 * @memberof Netx.custom.i18n
			 * @const
			 * @type {array}
			 * @default
			 */
			LANGUAGE_WHITELIST: [
				'de-DE',
				'en-US',
				'es-ES',
				'fr-CA',
				'fr-FR',
				'ja-JP',
				'jp-JP',
				'ko-KR',
				'nl-BE',
				'nl-NL',
				'zh-CH',
			],
			/**
			 * i18n - Path to translation file
			 * @memberof Netx.custom.i18n
			 * @const
			 * @type {string}
			 * @default
			 */
			PATH: '/locales/__lng__/locales',
			...Netx.custom.i18n,
		});
		// Initialize i18n next
		i18next
			// For loading .json files via XHR
			.use(i18nextXHRBackend)
			.use(i18nextBrowserLanguageDetector)
			.init(
				{
					// For loading json files via XHR
					backend: {
						// No multiloading (?de=true&de-at=true)
						allowMultiLoading: false,
						// Path to translation file
						loadPath: options.PATH,
					},
					// TODO: update translation files to be i18next JSON structure v3
					compatibilityJSON: 'v1',
					// Debug level output
					// debug: true,
					// Default namespace used if not passed to translation function
					defaultNS: options.NAMESPACE_DEFAULT,
					// Requires the i18next plugin i18next-browser-languagedetector
					// https://github.com/i18next/i18next-browser-languageDetector
					detection: {
						// // order and from where user language should be detected
						order: [
							'querystring',
							'cookie',
							'localStorage',
							'navigator',
							'htmlTag',
						],

						// // keys or params to lookup language from
						lookupQuerystring: 'lng',
						lookupCookie: 'locale',
						// lookupLocalStorage: 'i18nextLng',

						// // cache user language on
						caches: ['cookie'],

						// // optional expire and domain for set cookie
						// cookieMinutes: 10,
						// cookieDomain: 'myDomain',

						// // optional htmlTag with lang attribute, the default is:
						// htmlTag: document.documentElement
					},
					// Default language if none is detected (or not found)
					fallbackLng: 'en-US',
					// This ensures that if the key ins't found in the namespace specified it will try and find it in the default namespace
					fallbackNS: options.NAMESPACE_DEFAULT,
					// First check the browser for language preference and then fallback to default options if undefined
					// lng: nav.userLanguage || nav.language || options.LANGUAGE_DEFAULT,
					// Namespaces to load at initialization
					ns: options.NAMESPACES,
					//sendMissing: true,
					useCookie: true,
					// Allowed languages
					whitelist: options.LANGUAGE_WHITELIST,
				},
				// Ready callback
				function (error, instance) {
					// An error is a result of not receiving any locales from the server
					// Do not blow up the app - initialize the jquery piece

					jqueryI18next.init(i18next, $, {
						// appends $.t = i18next.t
						tName: 't',
						// appends $.i18n = i18next
						i18nName: 'i18n',
						// appends $(selector).localize(opts);
						handleName: 'localize',
						// selector for translating elements
						selectorAttr: 'data-i18n',
						// data-() attribute to grab target element to translate (if diffrent then itself)
						targetAttr: 'i18n-target',
						// data-() attribute that contains options, will load/set if useOptionsAttr = true
						optionsAttr: 'i18n-options',
						// see optionsAttr
						useOptionsAttr: false,
						// parses default values from content ele.val or ele.text
						parseDefaultValueFromContent: true,
					});

					if (error) {
						return reject(error);
					}

					// Set on html tag
					document.documentElement.setAttribute('lang', i18n.language);

					dispatcher.trigger('app:i18n:ready');

					resolve(i18next);
				},
			);
		/////////////////////////////////////
		// !i18n initialization
		/////////////////////////////////////
	});
};

export const i18n = i18next;

export default {
	initialize,
	i18n,
};
